<nav class="navbar navbar-expand-lg sticky-top">
    <div class="container">
        <a class="navbar-brand" href="#"><img src="assets/imgs/logo.svg" alt="MobileWise"></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li class="nav-item" *ngFor="let option of navOptions">
                    <a class="nav-link active" aria-current="page" (click)="scrollTo(option)">{{option}}</a>
                </li>
                <li class="buttons">
                    <a class="rounded-pill btn btn-lg btn-outline-dark" aria-current="page" (click)="navigateTo(['', 'login'])">Sign In</a>
               
                    <!-- <a class="rounded-pill btn btn-lg btn-dark" aria-current="page" (click)="navigateTo(['', 'signUp'])">Sign Up</a> -->
                </li>

            </ul>

        </div>
    </div>
</nav>